<script>
  import DifficultyLevelStars from '@/components/DifficultyLevelStars';

  export default {
    components: {
      DifficultyLevelStars
    },
    props: {
      label: {
        type: String,
        default: ''
      },
      labelMultiple: {
        type: String,
        default: 'Selected'
      },
      options: {
        type: Array,
        default: () => []
      },
      selectedOptions: {
        type: Array,
        default: () => []
      },
      loading: {
        type: Boolean,
        default: false
      },
      show: {
        type: Boolean,
        default: false
      },
      close: {
        type: Function,
        default: () => { }
      },
      radioButton: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        selected: [],
        buttonLabel: '',
        selectionChanged: false
      };
    },
    computed: {
      parsedOptions () {
        return this.options.map((option) => {
          if (typeof option === 'string') {
            option = {
              name: option,
              slug: option
            };
          }
          return option;
        });
      },
      isVisible () {
        return this.show;
      }
    },
    watch: {
      selectedOptions (val) {
        this.selected = Array.from(val);
        this.updateButtonLabel();
      }
    },
    created () {
      if (!this.selected.length) {
        this.selected = [...this.selectedOptions];
      }
      this.updateButtonLabel();
    },
    methods: {
      updateButtonLabel () {
        if (this.selected.length === 0) {
          this.buttonLabel = this.label;
          return;
        }
        this.buttonLabel = this.selected.length === 1 ? this.selected[0] : `${this.labelMultiple} • ${this.selected.length}`;
      },
      showHandler () {
        this.selectionChanged = false;
      },
      hideHandler () {
        if (this.selectionChanged) {
          this.updateButtonLabel();
          this.$emit('update', [...this.selected]);
        }
      },
      handleCheckbox (option) {
        if (this.selected.includes(option)) {
          this.selected.splice(this.selected.indexOf(option), 1);
        } else {
          this.selected.push(option);
        }
        this.selectionChanged = true;
      },
      // The radio variant (used by "Sorteer op") replaces the selection rather
      // than toggling it, so the modal can only ever report one value back.
      // This method was referenced by the template but never defined, so every
      // tap on a sort option threw (EXAMS-138, Menno 25-08).
      radioHandler (option) {
        this.selected = [option];
        this.selectionChanged = true;
      },
      clear () {
        this.selectionChanged = this.selected.length;
        this.selected = [];
      },
      closeModal () {
        this.$emit('close', null);
      },
      update (event) {
        this.$emit('update', [...this.selected], event);
      }
    },

  };
</script>

<template>
  <div
    class="sub-nav"
    :class="isVisible ? 'sub-nav-open' : ''"
  >
    <div class="sub-nav-inner">
      <div class="px-4 pt-4.5 pb-4 shadow flex justify-between items-center">
        <h3 class="text-1xl leading-1">
          {{ label }}
        </h3>
        <e-button
          type="quaternary"
          class="text-black filter-close-button"
          aria-label="Sluiten"
          @click="closeModal()"
        >
          <q-icon name="cross" />
        </e-button>
      </div>
      <ul class="p-6 pb-0">
        <li
          v-for="(option, i) in parsedOptions"
          :key="i"
          class="pb-6"
        >
          <e-checkbox
            v-if="!radioButton"
            :id="`${label}-checkbox-${i}`"
            class="w-full"
            :value="selected.includes(option.name)"
            @input="handleCheckbox(option.name)"
          >
            <span>
              {{ option.name }}
            </span> <difficulty-level-stars
              v-if="label === 'Moeilijkheidsniveau'"
              :star-amount="option.value"
            />
          </e-checkbox>
          <e-radio
            v-if="radioButton"
            :id="`${label}-radio-${i}`"
            class="w-full"
            :value="selected.includes(option.name)"
            :name="label"
            @input="radioHandler(option.name)"
          >
            <span>
              {{ option.name }}
            </span> <difficulty-level-stars
              v-if="label === 'Moeilijkheidsniveau'"
              :star-amount="option.value"
            />
          </e-radio>
        </li>
      </ul>
    </div>
    <div class="flex items-center justify-between gap-2 p-4 bg-white ">
      <e-button
        type="secondary"
        :disabled="selected.length === 0"
        class="w-full filter-clear-button"
        @click="clear"
      >
        Wis alle filters
      </e-button>
      <e-button
        class="w-full"
        @click="update($event)"
      >
        Toon resultaten
      </e-button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.sub-nav {
  @apply transition-transform duration-500 fixed bottom-0 translate-x-full top-0 right-0 w-full h-full bg-white overflow-y-auto;
  transform: translateX(100%);
}

.sub-nav-open.sub-nav {
  @apply z-30;
  transform: translateX(0);
  outline: 1px solid green;
}

.sub-nav-inner {
  height: calc(100% - 83px);
  overflow: scroll;
}

.filter-clear-button {
  @apply border-gray-500 border font-normal;
  box-shadow: none;
}
.filter-close-button {
  @apply text-black;
}
</style>
